package modysy.model

/** Represents the material of the physical body.
  *
  * @param density     The density of the body. It is used to calculate mass.
  * @param restitution The restitution coefficient that determines how much kinetic energy will be lost in collision.
  *                    When two bodies collide, the restitution of their collision
  *                    is the minimum of their restitutions. The value of 1 produces completely elastic
  *                    collisions with no loss of kinetic energy. The value of 0 produces collisions where objects
  *                    lose their speed in the direction of the collision normal. Restitution = 0 is currently buggy.
  */
case class Material(density: Double, restitution: Double) {
  require(density >= 0 && restitution >= 0 && restitution <= 1)
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/Material.scala